import { Component, OnInit } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { combineLatest, filter, map, take } from 'rxjs';
import { EquipmentFacadeService } from 'src/app/services/equipment-facade.service';
import { DesignService } from 'src/app/state';
import { ConstructionDetailsService } from 'src/app/state/construction/construction-details.service';
import { EquipmentBulkDetailsService } from 'src/app/state/equipment/equipment-bulk.service';

@Component({
  selector: 'em-mould-technical-specification',
  templateUrl: './mould-technical-specification.component.html',
  standalone: false,
})
export class MouldTechnicalSpecificationComponent implements OnInit {
  public readonly trackByRef = trackByRef;

  public equipments$ = this.equipmentBulkDetails.allEquipmentDetails$;
  public construction$ = this.constructionDetails.details$;

  public mtsData$ = combineLatest([this.equipments$, this.construction$]).pipe(
    map(([equipments, construction]) => {
      if (!construction) return [];

      return equipments.map((equipment) => ({
        equipment,
        construction,
        formattedWeight: equipment.weightOfObject.toString(),
      }));
    })
  );

  public loading$ = combineLatest([
    this.equipmentFacade.loading$,
    this.constructionDetails.loading$,
  ]).pipe(map(([eLoading, cLoading]) => eLoading || cLoading));

  public error$ = combineLatest([
    this.equipmentFacade.error$,
    this.constructionDetails.error$,
  ]).pipe(map(([eError, cError]) => eError || cError));

  public readonly errorMessage$ = this.error$.pipe(
    map((err) => {
      if (typeof err === 'string') return err;
      if (err instanceof Error) return err.message;

      return undefined;
    })
  );

  public constructor(
    private readonly designService: DesignService,
    private readonly equipmentFacade: EquipmentFacadeService,
    private readonly equipmentBulkDetails: EquipmentBulkDetailsService,
    private readonly constructionDetails: ConstructionDetailsService
  ) {}

  public ngOnInit(): void {
    this.designService.designId$
      .pipe(
        filter((id): id is string => !!id),
        take(1)
      )
      .subscribe((designId) => {
        this.equipmentBulkDetails.fetchAllFromDesign(designId);
      });

    // Fetch construction using equipmentId of first item
    this.equipments$
      .pipe(
        filter((equipments) => equipments.length > 0),
        take(1)
      )
      .subscribe((equipments) => {
        const equipmentId = equipments[0].equipmentNumber;

        if (equipmentId) {
          this.constructionDetails.loadByEquipmentId(equipmentId); // uses equipmentId here
        }
      });
  }
}
